<template>
  <div
    :class="{
      mail_box: true,
      mail_box_new: type === 'new',
      mail_box_received: type === 'received',
      mail_box_read: type === 'read'
    }"
  >
    <section class="no_padding">
      <h2 :class="{ no_mail: messages == null }">
        <v-icon class="icon_new" color="mail_box_headline_font">mdi-email-outline</v-icon>
        <v-icon class="icon_received" color="mail_box_headline_font">mdi-send-variant-outline</v-icon>
        <v-icon class="icon_read" color="mail_box_headline_font">mdi-email-open-outline</v-icon>
        {{ title }}
      </h2>

      <div v-if="messages != null">
        <div v-for="(entry, index) in messages" :key="index" class="mail_box_list">
          <div @click="goDetail(entry.id)">
            <div class="mail_box_list_title">
              <div class="mail_box_list_actor">
                <span v-if="type === 'new'" class="badge"></span>
                <span>{{ entry.actor.name }}</span>
              </div>
              <div class="mail_box_list_date">{{ entry.sent_at }}</div>
            </div>
            <div class="mail_box_list_text">
              <span class="mail_box_list_subject">{{ entry.subject }}</span>
              <span v-if="entry.voice" class="voice_label"><v-icon>mdi-volume-high</v-icon>先生の音声付きメッセージ</span>
              <span class="mail_box_list_body">{{ entry.body }}</span>
            </div>
          </div>
        </div>
        <p v-if="messages.length == 0" class="text_center mail_box_empty">
          {{ noMailWord }}メールはありません。
        </p>
      </div>
    </section>
    <section class="text_center">
      <ul v-if="messages != null" class="pagination pl-0">
        <li
          v-if="isPrev"
          class="prev link_main--text text-decoration-underline"
        ><span @click="goPagination('prev')">前へ</span></li>
        <li
          v-if="isNext"
          class="next link_main--text text-decoration-underline"
        ><span @click="goPagination('next')">次へ</span></li>
      </ul>
      <p>
        <router-link :to="backRoute()" class="arrow link_main--text">鑑定師別{{ noMailWord }}BOX一覧に戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { GET_MESSAGES_LIST } from '@/store/message/actions'
import { FETCH_MESSAGES_LIST } from '@/store/message/mutations'

export default {
  name: 'MailBox',
  props: {
    type: String,
    actor_id: Number
  },
  data () {
    return {
      page: this.$route.query.page || 0,
      currentPage: (this.$store.getters.messagesList != null) ? this.$store.getters.messagesList.current_page : 0,
      total: (this.$store.getters.messagesList != null) ? this.$store.getters.messagesList.total : 0,
      perPage: (this.$store.getters.messagesList != null) ? this.$store.getters.messagesList.per_page : 0,
      messages: (this.$store.getters.messagesList != null) ? this.$store.getters.messagesList.messages : null
    }
  },
  computed: {
    title () {
      let titleStr = ''
      switch (this.type) {
        case 'new':
          titleStr = '新着メール鑑定師BOX'
          break
        case 'received':
          titleStr = '送信メール鑑定師BOX'
          break
        case 'read':
          titleStr = '既読メール鑑定師BOX'
          break
      }
      return titleStr
    },
    component () {
      let componentStr = ''
      switch (this.type) {
        case 'new':
          componentStr = 'MailBoxNew'
          break
        case 'received':
          componentStr = 'MailBoxReceived'
          break
        case 'read':
          componentStr = 'MailBoxRead'
          break
      }
      return componentStr
    },
    noMailWord () {
      let str = ''
      switch (this.type) {
        case 'new':
          str = '新着'
          break
        case 'received':
          str = '送信'
          break
        case 'read':
          str = '既読'
          break
      }
      return str
    },
    isPrev () {
      return (this.currentPage > 1)
    },
    isNext () {
      return (this.currentPage < this.pageCount)
    },
    pageCount () {
      return Math.ceil(this.total / this.perPage)
    }
  },
  methods: {
    getMessages () {
      this.$store.dispatch(GET_MESSAGES_LIST, {
        params: {
          params: {
            type: this.type,
            actor_id: this.actor_id,
            page: this.page
          }
        }
      })
        .then((data) => {
          this.currentPage = data.current_page
          this.total = data.total
          this.perPage = data.per_page
          this.messages = data.messages
        })
        .catch(() => {
          this.$router.go(-1)
        })
    },
    goPagination (type) {
      const nextPage = (type === 'prev') ? this.currentPage - 1 : this.currentPage + 1
      const params = Vue.util.extend({}, this.$route.params)
      const query = Vue.util.extend({}, this.$route.query)
      query.page = String(nextPage)
      this.page = nextPage
      this.$router.pushIsses({ name: this.component, params: params, query: query })
    },
    goDetail (id) {
      this.$router.pushIsses({ name: 'MailDetail', params: { id: id, type: this.type } })
    },
    backRoute () {
      const nameMap = {
        new: 'MailThreadsNew',
        received: 'MailThreadsReceived',
        read: 'MailThreadsRead'
      }
      return {
        name: nameMap[this.type]
      }
    }
  },
  created () {
    this.getMessages()
  },
  watch: {
    page: function () {
      this.currentPage = this.total = this.perPage = 0
      this.messages = null

      this.getMessages()
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!(from.name === 'MailDetail')) {
      store.commit(FETCH_MESSAGES_LIST, null)
    }
    next()
  }
}
</script>
